import { useQuery } from '@fhs/client';
import { UserAccountsDocument } from '@fhs-legacy/frontend/src/generated/rbi-graphql';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';
import { useLocale } from '@fhs-legacy/frontend/src/state/intl';

import { UserAccountsResponse } from '../utils/types';

export const useUserAccountsQuery = () => {
  const { feCountryCode } = useLocale();
  return useQuery({
    queryKey: ['userAccounts'],
    queryFn: async () => {
      const { data } = await client.query({
        query: UserAccountsDocument,
        variables: { feCountryCode },
        fetchPolicy: 'network-only',
      });
      return data.userAccounts as UserAccountsResponse;
    },
  });
};
